import Swal from "sweetalert2";
import { wencesApi } from "@/api/wencesApi";
import { tn } from "@/i18n";

function esc(v) {
  const div = document.createElement("div");
  div.textContent = v == null ? "" : String(v);
  return div.innerHTML;
}

function formatNum(v) {
  if (v === undefined || v === null || v === "") return "—";
  const n = Number(v);
  return Number.isFinite(n) ? n.toLocaleString(undefined, { maximumFractionDigits: 2 }) : String(v);
}

/**
 * Carga en el embarque los costos de la negociación que la operación todavía no
 * tiene: pide los pendientes, confirma y los crea. Lo usan la vista Operación y
 * la pestaña Finance de la proforma.
 * Devuelve true si llegó a llamar al alta (hay que recargar los datos).
 */
export async function loadNegotiationExpensesForShipping(proformId, ship) {
  if (!proformId || !ship || !ship.shippingId) return false;

  let pending = [];
  let negotiationId = null;
  try {
    const { data } = await wencesApi.get(
      `/api/gotrading/fobtrading/operation/${proformId}/negotiation-expenses`
    );
    if (data && data.ok) {
      pending = Array.isArray(data.data.pending) ? data.data.pending : [];
      negotiationId = data.data.negotiationId || null;
    }
  } catch (e) {
    pending = [];
  }

  if (!pending.length) {
    await Swal.fire({
      icon: "info",
      title: tn("fobtrading.negotiationExpenses.nothingPendingTitle"),
      text: negotiationId
        ? tn("fobtrading.negotiationExpenses.nothingToLoad")
        : tn("fobtrading.negotiationExpenses.noNegotiation"),
    });
    return false;
  }

  const items = pending.map((item) => `<li>${esc(item.label)}: ${formatNum(item.amount)}</li>`).join("");
  const confirm = await Swal.fire({
    icon: "question",
    title: tn("fobtrading.negotiationExpenses.confirmTitle"),
    html:
      `<p>${tn("fobtrading.negotiationExpenses.confirmText", { shipping: esc(ship.name) })}</p>` +
      `<ul class="text-start">${items}</ul>`,
    showCancelButton: true,
    confirmButtonText: tn("fobtrading.negotiationExpenses.confirmButton"),
    cancelButtonText: tn("fobtrading.negotiationExpenses.cancelButton"),
  });
  if (!confirm.isConfirmed) return false;

  try {
    const { data } = await wencesApi.post(
      `/api/gotrading/fobtrading/operation/${proformId}/negotiation-expenses`,
      { shippingId: String(ship.shippingId) }
    );
    const created = (data && data.ok && data.data.created) || [];
    await Swal.fire({
      icon: created.length ? "success" : "info",
      title: tn("fobtrading.negotiationExpenses.doneTitle"),
      html: created.length
        ? `<ul class="text-start">${created
            .map((c) => `<li>${esc(c.label)} (${esc(c.contactName)}): ${formatNum(c.amount)}</li>`)
            .join("")}</ul>`
        : tn("fobtrading.negotiationExpenses.nothingToLoad"),
    });
  } catch (e) {
    await Swal.fire({
      icon: "error",
      title: tn("fobtrading.negotiationExpenses.loadError"),
      text: (e.response && e.response.data && e.response.data.error) || "",
    });
  }
  return true;
}
